import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShield = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M18.0898 4.38945C14.5969 3.76289 13.1527 3.29883 10 1.875C6.84727 3.29883 5.40313 3.76289 1.91016 4.38945C1.27734 14.4191 9.39766 17.8824 10 18.125C10.6023 17.8824 18.7227 14.4191 18.0898 4.38945Z",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgShield;
